import React from 'react';
import { 
  Typography, 
  Divider, 
  Grid, 
  Paper, 
  Box,
  Chip
} from "@mui/material";
import {
  CalendarToday,
  LocationOn,
  Person,
  Email,
  LocationCity,
  Store,
  Phone,
  Water,
  Inventory
} from '@mui/icons-material';

const ViewEtkPostModelJson = ({ etkPostModel, orderNumber }) => {
  if (!etkPostModel) {
    return null;
  }

  const InfoItem = ({ icon: Icon, label, value }) => (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
      <Icon sx={{ color: 'primary.main', fontSize: 18, mt: 0.2 }} />
      <Box sx={{ flex: 1 }}>
        <Typography variant="caption" color="text.secondary" component="span" sx={{ mr: 0.5 }}>
          {label}:
        </Typography>
        <Typography variant="body2" component="span" sx={{ fontWeight: 500 }}>
          {value || 'N/A'}
        </Typography>
      </Box>
    </Box>
  );

  return (
    <Paper elevation={0} sx={{ p: 2, border: '1px solid', borderColor: 'divider' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
        <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1.1rem' }}>
          ETK Post Model Information
        </Typography>
        {orderNumber && (
          <Chip 
            label={`Order #${orderNumber}`} 
            color="primary" 
            size="small"
            sx={{ fontWeight: 600, height: 24 }}
          />
        )}
      </Box>
      <Divider sx={{ mb: 1.5 }} />

      {/* First Row - Equal 4-column layout */}
      <Grid container spacing={1.5} sx={{ mb: 1 }}>
        <Grid item xs={12} sm={3}>
          <InfoItem 
            icon={CalendarToday}
            label="Sample Date"
            value={etkPostModel.sampleDate ? new Date(etkPostModel.sampleDate).toLocaleDateString() : ''}
          />
        </Grid>
        
        <Grid item xs={12} sm={3}>
          <InfoItem 
            icon={LocationOn}
            label="Sample Location"
            value={etkPostModel.sampleLocation}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InfoItem 
            icon={Inventory}
            label="Kit Type"
            value={etkPostModel.kitType}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InfoItem 
            icon={Person}
            label="Name"
            value={`${etkPostModel.firstName || ''} ${etkPostModel.lastName || ''}`.trim()}
          />
        </Grid>
      </Grid>

      {/* Second Row - Equal 4-column layout */}
      <Grid container spacing={1.5} sx={{ mb: 1 }}>
        <Grid item xs={12} sm={3}>
          <InfoItem 
            icon={Email}
            label="Email"
            value={etkPostModel.emailAddress}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InfoItem 
            icon={Phone}
            label="Phone"
            value={etkPostModel.phoneNum}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InfoItem 
            icon={LocationCity}
            label="City"
            value={etkPostModel.city}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InfoItem 
            icon={Store}
            label="Purchased From"
            value={etkPostModel.purchasedFrom}
          />
        </Grid>
      </Grid>

      {/* Third Row - Centered single item */}
      <Grid container spacing={1.5}>
        <Grid item xs={12} sm={3}>
          <InfoItem 
            icon={Water}
            label="Water Type"
            value={etkPostModel.waterType}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ViewEtkPostModelJson;